var Marionette = require('backbone.marionette');

var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');
var SuccessDialog = require('../common/ok-message-dialog-with-action');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var PersonDataView = Marionette.View.extend({
    template: require('../../templates/persons/person-data.html'),

    modelEvents: {
        'change': 'fieldsChanged'
    },

    regions: {
        confirmationModal: '#save-confirmation-modal',
        dialog: '#message-dialog',
        logoutAllConfirmationModel: '#logout-all-confirmation-modal'
    },

    ui: {
        resetToken: '#reset-token',
        logoutAll: '#logout-all',
        generateInstantToken: '#generate-instant-token',
        removePerson: '#remove-person'
    },

    events: {
        'click @ui.resetToken': 'onResetToken',
        'click @ui.logoutAll': 'onLogoutAll',
        'click @ui.generateInstantToken': 'onGenerateInstantToken',
        'click @ui.removePerson': 'removePerson'
    },

    childViewEvents: {
        'action:confirmed': 'onConfirmed'
    },

    callback: undefined,

    templateContext: function () {
        var that = this;
        var object = that.model.get('object');
        var positions = [
            (object.isAdmin ? "Admin" : ""),
            (object.isManager ? "Manager" : ""),
            (object.isMedicalDirector ? "Medical Director" : ""),
            (object.isOfficeAdministrator ? "Office Administrator" : ""),
            (object.isPatient ? "Patient" : ""),
            (object.isMd ? 'Provider' : '')
        ];
        return {
            byAdmin: that.byAdmin,
            isSelf: that.isSelf,
            position: positions.filter(function (item) {
                return item != '';
            }).join(", "),
            canEdit: that.canEdit,
            formattedDateTime: function (long) {
                return that.utils.longToDateTimeFormatted(long, 'MMM DD YYYY hh:mm A');
            },
            tels: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'PHONE'),
            faxes: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'FAX'),
            emails: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'EMAIL'),
            signedDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + '&PERSON_REVIEW_REQUEST=' + that.model.get('id') + '&PERSON_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
            + '&object_status=SIGNED&object_status=VIEWED',
            pendingDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + '&PERSON_REVIEW_REQUEST=' + that.model.get('id') + '&NOT_PERSON_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
            + '&object_status=IN_REVIEW',
            allDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + '&PERSON_REVIEW_REQUEST=' + that.model.get('id'),
            birthDate: (object.birthData == '' || object.birthData == null || object.birthData == 0 ? ''
                : that.utils.longToDateTimeFormattedInUtc(Number(object.birthData), 'MM/DD/YYYY'))
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'fieldsChanged', 'onResetToken', 'onRender', 'onConfirmed', 'onLogoutAll', 'resetToken', 'logoutAll', 'removePerson');
        this.model = options.model;
        this.byAdmin = options.byAdmin;
        this.isSelf = options.isSelf;
        this.utils = new CommonUtils();
        this.canEdit = options.canEdit;
    },

    onRender: function () {
        this.confirmationModal =
            new YesNoConfirmationModal({message: 'You are going to reset token for this user. Are you sure?'});
        this.showChildView('confirmationModal', this.confirmationModal);
        this.logoutConfirmationModal =
            new YesNoConfirmationModal({message: 'You are going to logout on all computers and this will reset token. Are you sure?'});
        this.showChildView('logoutAllConfirmationModel', this.logoutConfirmationModal);
        this.showChildView('dialog', new SuccessDialog({title: '', message: 'The token reset successfully'}));
    },

    fieldsChanged: function () {
        this.render();
    },

    onResetToken: function () {
        this.confirmationModal.show();
        this.callback = this.resetToken;
    },

    onConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.confirmationModal.hide();
            this.logoutConfirmationModal.hide();
        }
    },

    resetToken: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/person/reset/token/' + that.model.get('id'),
            dataType: 'text',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.getChildView('dialog').show();
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
            }
        });
    },

    onLogoutAll: function () {
        this.logoutConfirmationModal.show();
        this.callback = this.logoutAll;
    },

    logoutAll: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "DELETE",
            url: '/api/login/session?from_all=true',
            statusCode: {
                200: function () {
                    that.utils.hideSpinner();
                    Backbone.history.navigate('/', {trigger: true});
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
            }
        });
    },
    onGenerateInstantToken: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/utility/instant/token/' + that.model.get('id'),
            dataTyp: 'text',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    notificationsChannel.request('show:notification', {
                        message: "Token generated and sent.",
                        code: 200
                    });
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
            }
        });
    },

    removePerson: function () {
        var that = this;
        this.model.destroy({
            dataType: "text",
            success: function () {
                that.remove();
                that.unbind();
                Backbone.history.navigate('/patients', {
                    trigger: true
                });
            }
        });
    },

});

module.exports = PersonDataView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/person-data-view.js
// module id = 345
// module chunks = 0